import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminContacts() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/admin/contacts").then((r) => setItems(r.data.items)); }, []);
    return (
        <div data-testid="admin-contacts-page">
            <div className="eyebrow eyebrow--slate">Enquiries</div>
            <h1 className="font-serif text-4xl text-navy mt-3">Contact Enquiries</h1>
            <div className="mt-8 grid gap-4">
                {items.map((c) => (
                    <div key={c.contact_id} className="bg-white border border-slate-200 rounded-xl p-6" data-testid={`contact-card-${c.reference}`}>
                        <div className="flex justify-between items-start flex-wrap gap-3">
                            <div>
                                <div className="font-mono text-xs text-slate-400">{c.reference}</div>
                                <div className="font-serif text-lg text-navy mt-1">{c.name}</div>
                                <div className="text-slate-500 text-sm">{c.email} · {c.enquiry_type}</div>
                            </div>
                            <span className="text-xs font-mono uppercase tracking-widest text-[#E8B923] border border-[#E8B923] rounded-full px-3 py-1">{c.status}</span>
                        </div>
                        <div className="mt-4 text-sm text-slate-600 border-l-2 border-slate-200 pl-3">{c.message}</div>
                    </div>
                ))}
                {!items.length && <div className="text-center py-12 text-slate-400">No enquiries yet</div>}
            </div>
        </div>
    );
}
